import { useDispatch } from 'react-redux';
import React, { useCallback } from 'react';
import { PropTypes } from 'prop-types';

import { MessageDescriptorPropType } from '../../../prop-types/intl';
import PrintDocumentMenuItem from '../../../components/print-document-menu-item';

export const GenericPrintDocumentMenuItem = ({ name, action, disabled = false, isFeatureEnabled = true }) => {
  const dispatch = useDispatch();
  const onClick = useCallback(() => {
    dispatch(action());
  }, [dispatch, action]);

  return <PrintDocumentMenuItem disabled={disabled} isFeatureEnabled={isFeatureEnabled} name={name} onClick={onClick} />;
};

GenericPrintDocumentMenuItem.propTypes = {
  name: MessageDescriptorPropType.isRequired,
  action: PropTypes.func.isRequired,
};
